<template>
  <v-container fluid>
    <v-toolbar>
      <v-toolbar-title>{{ $t('NOTIFICATIONS.ITEMS') }}</v-toolbar-title>

      <v-spacer />

      <v-btn
        dark
        color="indigo"
        @click="$router.push({ name: 'notifications.create' })"
      >
        <v-icon left>mdi-plus</v-icon>
        {{ $t('ITEM.NEW') }} {{ $t('NOTIFICATIONS.ITEM') }}
      </v-btn>
    </v-toolbar>

    <v-sheet class="mt-5 pa-5" tile>
      <notifications-list-filter @setFilters="setFilters" />

      <notifications-list
        :meta="meta"
        :items="items"
        :options.sync="options"
        @show="show"
      />
    </v-sheet>
  </v-container>
</template>

<script>
import NotificationsListFilter from '../components/NotificationsListFilter.vue';
import NotificationsList from '../components/NotificationsList.vue';
import { mapActions, mapState } from 'vuex';
import listOptions from '@/modules/_global/mixins/list-options';

export default {
  name: 'NotificationsPage',

  components: {
    NotificationsListFilter,
    NotificationsList
  },

  mixins: [listOptions],

  data: () => ({
    options: {
      page: 1,
      itemsPerPage: 10,
      sortBy: ['id'],
      sortDesc: [true],
      groupBy: [],
      groupDesc: [],
      mustSort: false,
      multiSort: false
    }
  }),

  computed: {
    ...mapState('notification', ['paginationOptions'])
  },

  methods: {
    ...mapActions('notification', ['getItemsList']),

    show(item) {
      this.$router.push({
        name: 'notifications.show',
        params: { id: item.id }
      });
    }
  }
};
</script>
